<template>
  <div class="min-h-screen bg-white flex items-center justify-center">
    <!-- Centered Content -->
    <div class="w-full max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
      
      <!-- Logo and Brand -->
      <div class="text-center mb-4">
        <div class="w-64 h-64 sm:w-96 sm:h-96 mx-auto mb-1 rounded-xl p-4 bg-white/80 backdrop-blur-sm">
          <img 
            src="/annzz_logo.jpeg" 
            alt="Annzz Logo" 
            class="w-full h-full object-contain"
          />
        </div>
      </div>

      <!-- Toggle Switch Section -->
      <div class="flex justify-center mb-8">
        <div class="bg-white rounded-2xl p-2 border border-gray-200 shadow-xl w-full max-w-2xl">
          <div class="relative flex bg-gray-100 rounded-xl p-1 overflow-hidden">
            <!-- Sliding Background Indicator -->
            <div 
              class="toggle-slider absolute top-1 bottom-1 bg-gradient-to-r from-orange-600 to-red-600 rounded-lg shadow-lg transition-all duration-300 ease-in-out"
              :style="{
                left: activeSection === 'catalogue' ? '4px' : activeSection === 'secret' ? 'calc(33.333% + 2px)' : 'calc(66.666% + 4px)',
                width: 'calc(33.333% - 8px)'
              }"
            ></div>
            
            <!-- Toggle Buttons -->
            <button
              @click="activeSection = 'catalogue'"
              :class="[
                'toggle-button relative z-10 flex-1 min-w-0 px-2 sm:px-4 py-3 rounded-lg font-semibold flex items-center justify-center space-x-1 sm:space-x-2 group',
                activeSection === 'catalogue' 
                  ? 'text-white glow-effect active' 
                  : 'text-gray-700 hover:text-gray-900'
              ]"
            >
              <svg 
                class="icon-scale w-5 h-5 flex-shrink-0" 
                :class="activeSection === 'catalogue' ? 'scale-110' : 'group-hover:scale-110'"
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
              </svg>
              <span class="transition-all duration-300 text-xs sm:text-sm text-center leading-tight" :class="activeSection === 'catalogue' ? 'font-bold' : 'font-medium'">
                Private Catalogue
              </span>
            </button>
            
            <button
              @click="activeSection = 'secret'"
              :class="[
                'toggle-button relative z-10 flex-1 min-w-0 px-2 sm:px-4 py-3 rounded-lg font-semibold flex items-center justify-center space-x-1 sm:space-x-2 group',
                activeSection === 'secret' 
                  ? 'text-white glow-effect active' 
                  : 'text-gray-700 hover:text-gray-900'
              ]"
            >
              <svg 
                class="icon-scale w-5 h-5 flex-shrink-0" 
                :class="activeSection === 'secret' ? 'scale-110' : 'group-hover:scale-110'"
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z" />
              </svg>
              <span class="transition-all duration-300 text-xs sm:text-sm text-center leading-tight" :class="activeSection === 'secret' ? 'font-bold' : 'font-medium'">
                Secret Access
              </span>
            </button>

            <button
              @click="activeSection = 'contact'"
              :class="[
                'toggle-button relative z-10 flex-1 min-w-0 px-2 sm:px-4 py-3 rounded-lg font-semibold flex items-center justify-center space-x-1 sm:space-x-2 group',
                activeSection === 'contact' 
                  ? 'text-white glow-effect active' 
                  : 'text-gray-700 hover:text-gray-900'
              ]"
            >
              <svg 
                class="icon-scale w-5 h-5 flex-shrink-0" 
                :class="activeSection === 'contact' ? 'scale-110' : 'group-hover:scale-110'"
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <span class="transition-all duration-300 text-xs sm:text-sm text-center leading-tight" :class="activeSection === 'contact' ? 'font-bold' : 'font-medium'">
                Contact Us
              </span>
            </button>
          </div>
        </div>
      </div>

      <!-- Dynamic Content Section -->
      <div class="max-w-lg mx-auto">
        <!-- Private Catalogue Section -->
        <div v-if="activeSection === 'catalogue'" class="text-center">
            <p class="text-gray-600 mb-8 font-light text-lg">
              Access our exclusive jewelry collection
            </p>
            
            <!-- Main CTA Button -->
            <button 
              @click="showOTPGate = true"
              class="group relative inline-flex items-center px-12 py-6 text-2xl font-semibold text-white bg-gradient-to-r from-orange-600 via-red-600 to-red-700 rounded-2xl shadow-2xl hover:shadow-3xl transition-all duration-300 transform hover:scale-105 border-2 border-white/20"
            >
              <span class="relative z-10">Enter Private Catalogue</span>
              <div class="absolute inset-0 bg-gradient-to-r from-orange-700 via-red-700 to-red-800 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </button>
        </div>

        <!-- Secret Product Access Section -->
        <div v-if="activeSection === 'secret'" class="text-center">
            <p class="text-gray-600 mb-8 font-light text-lg">
              Access exclusive products using secret keys
            </p>
            
            <!-- Secret Key Input Form -->
            <div class="bg-white rounded-2xl p-6 border border-gray-200 shadow-xl">
              <form @submit.prevent="accessSecretProduct" class="space-y-4">
                <div>
                  <input
                    v-model="secretKeyInput"
                    type="text"
                    placeholder="Enter your secret key"
                    class="w-full border border-orange-200 rounded-xl px-4 py-3 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-all duration-200 text-center"
                    :class="{ 'border-red-500': secretKeyError }"
                  />
                  <p v-if="secretKeyError" class="mt-1 text-sm text-red-600">{{ secretKeyError }}</p>
                </div>
                <button 
                  type="submit"
                  :disabled="!secretKeyInput.trim() || loadingSecret"
                  class="w-full bg-gradient-to-r from-orange-600 to-red-600 text-white py-3 rounded-xl hover:from-orange-700 hover:to-red-700 transition-all duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <span v-if="loadingSecret">Checking...</span>
                  <span v-else>🔓 Access Product</span>
                </button>
              </form>
            </div>

            <!-- Product Display Card -->
            <div v-if="secretProduct" class="mt-6 bg-white rounded-2xl shadow-xl border border-orange-200/50 overflow-hidden">
              <div class="p-6">
                <div class="flex items-start justify-between mb-4">
                  <div class="flex-1">
                    <h2 class="text-2xl font-bold text-gray-900 mb-2 font-luxury">{{ secretProduct.name }}</h2>
                    <p class="text-lg text-gray-600 font-light mb-2">SKU: {{ secretProduct.sku }}</p>
                    <p class="text-sm text-orange-600 font-medium">
                      🔐 Accessed via Secret Key
                    </p>
                  </div>
                  <div class="ml-4">
                    <span class="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-green-100 text-green-800">
                      {{ secretProduct.category }}
                    </span>
                  </div>
                </div>

                <!-- Product Image -->
                <div class="mb-4">
                  <div 
                    @click="openImageModal"
                    class="aspect-w-1 aspect-h-1 bg-gradient-to-br from-orange-100 to-red-200 rounded-xl overflow-hidden shadow-lg cursor-pointer hover:shadow-xl transition-all duration-300 transform hover:scale-105"
                  >
                    <div class="w-full h-48 bg-gradient-to-br from-orange-100 to-red-200 flex items-center justify-center relative group">
                      <span class="text-orange-600 text-4xl font-bold">{{ secretProduct.name.charAt(0) }}</span>
                      <!-- View Images Overlay -->
                      <div class="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
                        <div class="bg-white/90 backdrop-blur-sm rounded-lg px-3 py-1 text-sm font-medium text-gray-900">
                          <svg class="w-4 h-4 inline mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                          </svg>
                          View Images
                        </div>
                      </div>
                    </div>
                  </div>
                  <p class="text-center text-sm text-gray-600 font-light mt-2">Click to view product images</p>
                </div>

                <!-- Product Description -->
                <div v-if="secretProduct.description" class="bg-white rounded-xl p-4 border border-orange-200/50 mb-4">
                  <h3 class="text-lg font-semibold text-gray-900 mb-2 font-luxury">Description</h3>
                  <p class="text-gray-600 font-light leading-relaxed text-sm">{{ secretProduct.description }}</p>
                </div>

                <!-- Action Buttons -->
                <div class="space-y-3">
                  <button 
                    @click="addSecretProductToCart"
                    :disabled="addingToCart"
                    class="w-full bg-gradient-to-r from-orange-600 to-red-600 text-white py-3 rounded-xl hover:from-orange-700 hover:to-red-700 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <span v-if="addingToCart">Adding to Cart...</span>
                    <span v-else>Add to Cart</span>
                  </button>
                  
                  <button 
                    @click="clearSecretProduct"
                    class="w-full text-center bg-white border border-orange-200 text-orange-600 py-3 rounded-xl hover:bg-orange-50 transition-all duration-200 font-medium"
                  >
                    View Different Product
                  </button>
                </div>
              </div>
            </div>

            <!-- Demo Section -->
            <div v-if="!secretProduct" class="mt-6 bg-gradient-to-r from-orange-50 to-red-50 rounded-xl p-6 border border-orange-200/50">
              <h4 class="font-semibold text-gray-900 mb-3">Test Secret Key Access</h4>
              <p class="text-sm text-gray-600 mb-4 font-light">
                Use this secret key to access an exclusive product:
              </p>
              <div class="bg-orange-100 rounded-lg p-3 mb-4">
                <code class="text-orange-800 font-mono text-sm">EXCLUSIVE-2024</code>
              </div>
              <button 
                @click="testSecretKey"
                class="inline-flex items-center px-4 py-2 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-lg hover:from-orange-700 hover:to-red-700 transition-all duration-200 font-medium"
              >
                🔓 Test Secret Product
              </button>
            </div>
        </div>

        <!-- Contact Us Section -->
        <div v-if="activeSection === 'contact'" class="text-center">
          <p class="text-gray-600 mb-8 font-light text-lg">
            Get in touch with our team
          </p>
          
          <!-- Contact Information Cards -->
          <div class="space-y-6">
            <!-- Phone Numbers -->
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="bg-gradient-to-r from-orange-50 to-red-50 rounded-2xl p-6 border border-orange-200/50 hover:shadow-lg transition-all duration-300">
                <div class="flex items-center justify-center mb-3">
                  <div class="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                    <svg class="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                </div>
                <h3 class="text-lg font-semibold text-gray-900 mb-2">SAJIL</h3>
                <a href="tel:+918281887403" class="text-orange-600 hover:text-orange-800 font-semibold text-lg">
                  +91 828 188 7403
                </a>
              </div>
              
              <div class="bg-gradient-to-r from-orange-50 to-red-50 rounded-2xl p-6 border border-orange-200/50 hover:shadow-lg transition-all duration-300">
                <div class="flex items-center justify-center mb-3">
                  <div class="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                    <svg class="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                  </div>
                </div>
                <h3 class="text-lg font-semibold text-gray-900 mb-2">WINSON</h3>
                <a href="tel:+919745222188" class="text-orange-600 hover:text-orange-800 font-semibold text-lg">
                  +91 974 522 2188
                </a>
              </div>
            </div>

            <!-- Email -->
            <div class="bg-gradient-to-r from-orange-50 to-red-50 rounded-2xl p-6 border border-orange-200/50 hover:shadow-lg transition-all duration-300">
              <div class="flex items-center justify-center mb-3">
                <div class="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                  <svg class="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
              </div>
              <h3 class="text-lg font-semibold text-gray-900 mb-2">Email</h3>
              <a href="mailto:annzzgold@gmail.com" class="text-orange-600 hover:text-orange-800 font-semibold text-lg">
                annzzgold@gmail.com
              </a>
            </div>

            <!-- Address -->
            <div class="bg-gradient-to-r from-orange-50 to-red-50 rounded-2xl p-6 border border-orange-200/50 hover:shadow-lg transition-all duration-300">
              <div class="flex items-center justify-center mb-3">
                <div class="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
                  <svg class="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
              </div>
              <h3 class="text-lg font-semibold text-gray-900 mb-2">Address</h3>
              <p class="text-gray-700 leading-relaxed">
                10/581, 582, 2nd Floor,<br>
                Pavana Building, Pallikkulam Road,<br>
                Thrissur, Kerala - 680 001
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Image Viewer Modal -->
    <div v-if="showImageModal" class="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div class="absolute inset-0 bg-black/80 backdrop-blur-sm" @click="closeImageModal"></div>
      <div class="relative bg-white rounded-2xl shadow-2xl border border-orange-200/20 max-w-4xl w-full max-h-[90vh] overflow-hidden">
        <!-- Modal Header -->
        <div class="flex items-center justify-between p-6 border-b border-orange-200/50">
          <div class="flex items-center">
            <div class="w-10 h-10 mr-3">
              <img 
                src="/logo6.png" 
                alt="Annzz Logo" 
                class="w-full h-full object-contain"
              />
            </div>
            <div>
              <h3 class="text-xl font-bold text-gray-900 font-luxury">{{ secretProduct?.name }}</h3>
              <p class="text-sm text-gray-600 font-light">Product Images</p>
            </div>
          </div>
          <button 
            @click="closeImageModal"
            class="w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors duration-200"
          >
            <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Image Content -->
        <div class="p-6">
          <div v-if="productImages.length > 0" class="space-y-6">
            <!-- Main Image Display -->
            <div class="relative">
              <div class="w-full max-w-3xl mx-auto aspect-w-16 aspect-h-9 bg-black rounded-xl overflow-hidden flex items-center justify-center" style="min-height:360px; max-height:480px;">
                <img 
                  :src="getImageUrl(currentImage)" 
                  :alt="`${secretProduct?.name} - Image ${currentImageIndex + 1}`"
                  class="w-full h-full object-contain object-center"
                  style="min-height:360px; max-height:480px;"
                  @error="handleImageError"
                />
              </div>
              
              <!-- Navigation Arrows -->
              <button 
                v-if="productImages.length > 1"
                @click="previousImage"
                class="absolute left-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:bg-white transition-all duration-200"
              >
                <svg class="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
              </button>
              
              <button 
                v-if="productImages.length > 1"
                @click="nextImage"
                class="absolute right-4 top-1/2 transform -translate-y-1/2 w-12 h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg hover:bg-white transition-all duration-200"
              >
                <svg class="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
              </button>

              <!-- Image Counter -->
              <div class="absolute bottom-4 left-1/2 transform -translate-x-1/2 bg-black/70 backdrop-blur-sm rounded-lg px-3 py-1 text-white text-sm font-medium">
                {{ currentImageIndex + 1 }} / {{ productImages.length }}
              </div>
            </div>

            <!-- Thumbnail Navigation -->
            <div v-if="productImages.length > 1" class="flex space-x-2 overflow-x-auto pb-2">
              <button
                v-for="(image, index) in productImages"
                :key="index"
                @click="setCurrentImage(index)"
                :class="[
                  'flex-shrink-0 w-20 h-20 rounded-lg overflow-hidden border-2 transition-all duration-200',
                  currentImageIndex === index 
                    ? 'border-orange-500 shadow-lg' 
                    : 'border-gray-200 hover:border-orange-300'
                ]"
              >
                <img 
                  :src="getImageUrl(image)" 
                  :alt="`Thumbnail ${index + 1}`"
                  class="w-full h-full object-contain"
                  @error="handleImageError"
                />
              </button>
            </div>
          </div>

          <!-- No Images State -->
          <div v-else class="text-center py-12">
            <div class="w-24 h-24 bg-gradient-to-br from-orange-100 to-red-200 rounded-full flex items-center justify-center mx-auto mb-4">
              <svg class="w-12 h-12 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 class="text-lg font-semibold text-gray-900 mb-2 font-luxury">No Images Available</h3>
            <p class="text-gray-600 font-light">This product doesn't have any images uploaded yet.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- OTP Gate Modal with Luxury Design -->
    <div v-if="showOTPGate" class="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" @click="closeOTPGate"></div>
      <div class="relative bg-white rounded-2xl shadow-2xl border border-orange-200/20 max-w-md w-full max-h-[90vh] overflow-hidden">
        <div class="text-center mb-6 p-6 border-b border-gray-100">
          <div class="w-16 h-16 mx-auto mb-4">
            <img 
              src="/logo6.png" 
              alt="Annzz Logo" 
              class="w-full h-full object-contain"
            />
          </div>
          <h2 class="text-3xl font-bold text-gray-900 mb-2 font-luxury">Welcome to Annzz</h2>
          <p class="text-gray-600">Choose your preferred access method</p>
        </div>

        <!-- Luxury Tabs -->
        <div class="flex justify-center mb-6 bg-gray-100 rounded-lg p-1 mx-6">
          <button
            :class="['px-6 py-3 rounded-lg font-medium focus:outline-none transition-all duration-200', tab === 'token' ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-lg' : 'text-gray-700 hover:text-gray-900']"
            @click="tab = 'token'"
          >
            Register via Token
          </button>
          <button
            :class="['px-6 py-3 rounded-lg font-medium focus:outline-none transition-all duration-200 ml-2', tab === 'password' ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-lg' : 'text-gray-700 hover:text-gray-900']"
            @click="tab = 'password'"
          >
            Login
          </button>
        </div>

        <!-- Scrollable Content Area -->
        <div class="overflow-y-auto max-h-[60vh] px-6 pb-6">
          <!-- Register via Token Form -->
          <div v-if="tab === 'token'">
            <div v-if="tokenStep === 1">
              <label class="block text-lg font-medium text-gray-700 mb-2">Enter your invite token</label>
              <input v-model="inviteToken" type="text" placeholder="Paste your invite token here" class="w-full px-4 py-3 border border-orange-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 mb-4" />
              <button @click="validateToken" :disabled="tokenLoading || !inviteToken.trim()" class="w-full bg-gradient-to-r from-orange-600 to-red-600 text-white py-3 rounded-lg font-semibold hover:from-orange-700 hover:to-red-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
                <span v-if="tokenLoading">Validating...</span>
                <span v-else>Validate Token</span>
              </button>
              <div v-if="tokenError" class="mt-4 bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-center text-sm">
                <div class="flex items-center justify-center">
                  <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                  </svg>
                  {{ getErrorMessage(tokenError) }}
                </div>
              </div>
            </div>
            <div v-else-if="tokenStep === 2">
              <form @submit.prevent="registerViaToken" class="space-y-4">
                <!-- Company Name (Read-only) -->
                <div>
                  <label class="block text-sm font-medium text-gray-700 mb-1">Company Name</label>
                  <input type="text" :value="inviteDetails.company_name" disabled class="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-600" />
                </div>

                <!-- Username and Password Row -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Username *</label>
                    <input v-model="tokenForm.username" type="text" required placeholder="Enter username" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Password *</label>
                    <div class="relative">
                      <input v-model="tokenForm.password" :type="showRegisterPassword ? 'text' : 'password'" required minlength="6" placeholder="Min 6 characters" class="w-full px-3 py-2 pr-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
                      <button
                        type="button"
                        @click="showRegisterPassword = !showRegisterPassword"
                        class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
                        aria-label="Toggle password visibility"
                      >
                        <svg v-if="showRegisterPassword" class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L12 12m-2.122-2.122L7.758 7.758M12 12l2.122 2.122m-2.122-2.122L7.758 7.758m6.364 6.364L12 12m2.122 2.122l2.122 2.122" />
                        </svg>
                        <svg v-else class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Customer-specific fields -->
                <div v-if="inviteDetails?.role === 'customer'">
                  <label class="block text-sm font-medium text-gray-700 mb-1">GST Number (Optional)</label>
                  <input v-model="tokenForm.gst_number" type="text" placeholder="22AAAAA0000A1Z5" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500" @blur="validateGST" />
                  <p v-if="gstError" class="text-red-600 text-xs mt-1">{{ gstError }}</p>
                </div>

                <!-- Contact Person -->
                <div v-if="inviteDetails?.role === 'customer'">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Contact Person</label>
                  <input v-model="tokenForm.contact_person" type="text" placeholder="Enter contact person name" class="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500" />
                </div>

                <!-- Email and Phone Row -->
                <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
                    <input v-model="tokenForm.email" type="email" disabled class="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-600" />
                  </div>
                  <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                    <input v-model="tokenForm.phone" type="tel" disabled class="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-600" />
                  </div>
                </div>

                <!-- Address (Customer only) -->
                <div v-if="inviteDetails?.role === 'customer'">
                  <label class="block text-sm font-medium text-gray-700 mb-1">Address</label>
                  <textarea v-model="tokenForm.address" disabled rows="3" class="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-100 text-gray-600 resize-none"></textarea>
                </div>

                <button type="submit" :disabled="tokenLoading" class="w-full bg-gradient-to-r from-orange-600 to-red-600 text-white py-3 rounded-lg font-semibold hover:from-orange-700 hover:to-red-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed">
                  <span v-if="tokenLoading">Registering...</span>
                  <span v-else>Complete Registration</span>
                </button>
              </form>
              <div v-if="tokenError" class="mt-4 bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-center text-sm">
                <div class="flex items-center justify-center">
                  <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                  </svg>
                  {{ getErrorMessage(tokenError) }}
                </div>
              </div>
            </div>
            <div v-else-if="tokenStep === 3">
              <div class="text-center">
                <div class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg class="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <h3 class="text-2xl font-bold text-green-700 mb-4">Registration Successful!</h3>
                <p class="text-gray-700 mb-4">Your account is ready. Log in with your email or phone and the password you just set.</p>
                <button @click="continueToLogin" class="px-6 py-3 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-lg font-semibold hover:from-orange-700 hover:to-red-700 transition-all duration-200">
                  Continue to Login
                </button>
              </div>
            </div>
          </div>
          <!-- Login Form -->
          <div v-if="tab === 'password'">
            <form @submit.prevent="loginWithPassword" class="space-y-4">
              <div>
                <label for="email" class="block text-sm font-medium text-gray-700 mb-2">
                  Email or Phone
                </label>
                <input
                  id="email"
                  v-model="email"
                  type="text"
                  placeholder="Enter your email or phone"
                  :class="[
                    'w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors',
                    emailError ? 'border-red-500' : 'border-gray-300'
                  ]"
                  @input="emailError = ''; generalError = ''"
                  required
                />
                <p v-if="emailError" class="text-red-600 text-xs mt-1">{{ emailError }}</p>
              </div>

              <div>
                <label for="password" class="block text-sm font-medium text-gray-700 mb-2">
                  Password
                </label>
                <div class="relative">
                  <input
                    id="password"
                    v-model="password"
                    :type="showLoginPassword ? 'text' : 'password'"
                    placeholder="Enter your password"
                    :class="[
                      'w-full px-4 py-3 pr-10 border rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 transition-colors',
                      passwordError ? 'border-red-500' : 'border-gray-300'
                    ]"
                    @input="passwordError = ''; generalError = ''"
                    required
                  />
                  <button
                    type="button"
                    @click="showLoginPassword = !showLoginPassword"
                    class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 transition-colors"
                    aria-label="Toggle password visibility"
                  >
                    <svg v-if="showLoginPassword" class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L12 12m-2.122-2.122L7.758 7.758M12 12l2.122 2.122m-2.122-2.122L7.758 7.758m6.364 6.364L12 12m2.122 2.122l2.122 2.122" />
                    </svg>
                    <svg v-else class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  </button>
                </div>
                <p v-if="passwordError" class="text-red-600 text-xs mt-1">{{ passwordError }}</p>
              </div>

              <!-- Error Display -->
              <div v-if="generalError" class="bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-center text-sm">
                <div class="flex items-center justify-center">
                  <svg class="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd" />
                  </svg>
                  {{ generalError }}
                </div>
              </div>

              <div class="flex space-x-4">
                <button
                  type="button"
                  @click="closeOTPGate"
                  class="flex-1 px-6 py-3 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  class="flex-1 px-6 py-3 bg-gradient-to-r from-amber-500 to-yellow-500 text-white rounded-lg hover:from-amber-600 hover:to-yellow-600 transition-all duration-200 shadow-lg"
                  :disabled="loading"
                >
                  <span v-if="loading" class="spinner w-4 h-4 mr-2"></span>
                  Login
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { ref, computed, nextTick, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useUserStore } from '../stores/user'
import api from '../services/api'
import { useNotificationStore } from '../stores/notification'

export default {
  name: 'Landing',
  setup() {
    const router = useRouter()
    const userStore = useUserStore()
    
    // State
    const showOTPGate = ref(false)
    const tab = ref('password') // Default to Token tab
    const activeSection = ref('catalogue') // Default to catalogue section
    
    // Password login state
    const email = ref('')
    const password = ref('')
    const showLoginPassword = ref(false)
    const emailError = ref('')
    const passwordError = ref('')
    const generalError = ref('')
    const loading = ref(false)
    
    // Secret key access state
    const secretKeyInput = ref('')
    const secretKeyError = ref('')
    const loadingSecret = ref(false)
    const secretProduct = ref(null)
    const addingToCart = ref(false)
    const showImageModal = ref(false)
    const currentImageIndex = ref(0)
    
    // Computed
    const productImages = computed(() => {
      if (!secretProduct.value?.images) return []
      try {
        return Array.isArray(secretProduct.value.images) 
          ? secretProduct.value.images 
          : JSON.parse(secretProduct.value.images)
      } catch {
        return []
      }
    })

    const currentImage = computed(() => {
      if (productImages.value.length === 0) return ''
      return productImages.value[currentImageIndex.value] || productImages.value[0]
    })
    
    // Methods
    const closeOTPGate = () => {
      showOTPGate.value = false
      resetForm()
    }

    // After registering, switch straight to the login tab with the new email filled in
    const continueToLogin = () => {
      const registeredEmail = tokenForm.value.email
      resetForm()
      email.value = registeredEmail
    }
    
    const resetForm = () => {
      email.value = ''
      password.value = ''
      emailError.value = ''
      passwordError.value = ''
      generalError.value = ''
      tab.value = 'password' // Always default to login tab
      tokenStep.value = 1 // Reset token registration flow
      inviteToken.value = ''
      tokenError.value = ''
      inviteDetails.value = null
      tokenForm.value = { username: '', password: '', gst_number: '', contact_person: '', email: '', phone: '', address: '' }
      secretKeyInput.value = ''
      secretKeyError.value = ''
      loadingSecret.value = false
    }
    
    const switchTab = (newTab) => {
      tab.value = newTab
      // Clear all errors when switching tabs
      emailError.value = ''
      passwordError.value = ''
      generalError.value = ''
      if (newTab === 'token') {
        tokenStep.value = 1
        inviteToken.value = ''
        tokenError.value = ''
        inviteDetails.value = null
        tokenForm.value = { username: '', password: '', gst_number: '', contact_person: '', email: '', phone: '', address: '' }
      }
    }
    
    // Indian phone number validation and formatting
    const validateIndianPhoneNumber = (phone) => {
      // Remove all spaces and special characters except + and digits
      const cleaned = phone.replace(/[^\d+]/g, '')
      
      // Check if it's a valid Indian number
      const indianPhoneRegex = /^(\+91)?[6-9]\d{9}$/
      
      if (!indianPhoneRegex.test(cleaned)) {
        return { isValid: false, error: 'Please enter a valid 10-digit Indian phone number' }
      }
      
      // Format the number with +91 prefix
      let formattedNumber = cleaned
      if (cleaned.startsWith('+91')) {
        formattedNumber = cleaned
      } else if (cleaned.length === 10) {
        formattedNumber = '+91' + cleaned
      } else {
        return { isValid: false, error: 'Please enter a valid 10-digit Indian phone number' }
      }
      
      return { isValid: true, formatted: formattedNumber }
    }
    
    const validateIdentifier = () => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      
      if (!email.value) {
        emailError.value = 'Email is required'
        return false
      }
      
      // Check if it's an email
      if (emailRegex.test(email.value)) {
        emailError.value = ''
        return true
      }
      
      // It's a phone number, validate it
      const phoneValidation = validateIndianPhoneNumber(email.value)
      if (!phoneValidation.isValid) {
        emailError.value = phoneValidation.error
        return false
      }
      
      // Update the identifier with formatted version
      email.value = phoneValidation.formatted
      emailError.value = ''
      return true
    }
    
    // Real-time validation functions
    const validateIdentifierInput = () => {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      
      if (!email.value) {
        emailError.value = ''
        return
      }
      
      // Check if it's an email
      if (emailRegex.test(email.value)) {
        emailError.value = ''
        return
      }
      
      // It's a phone number, validate it
      const phoneValidation = validateIndianPhoneNumber(email.value)
      if (!phoneValidation.isValid) {
        emailError.value = phoneValidation.error
      } else {
        emailError.value = ''
      }
    }
    
    const validatePhoneInput = () => {
      if (!email.value) {
        emailError.value = ''
        return
      }
      
      const phoneValidation = validateIndianPhoneNumber(email.value)
      if (!phoneValidation.isValid) {
        emailError.value = phoneValidation.error
      } else {
        emailError.value = ''
      }
    }
    
    const loginWithPassword = async () => {
      if (!validateIdentifier()) return
      
      loading.value = true
      // Clear all errors at the start
      emailError.value = ''
      passwordError.value = ''
      generalError.value = ''
      try {

        // validateIdentifier() has already formatted phone numbers to +91XXXXXXXXXX
        const identifier = email.value.includes('@') ? { email: email.value } : { phone: email.value }
        const result = await userStore.login({
          ...identifier,
          password: password.value
        })
        
        console.log('Login result:', result)
        
        if (result.success) {
          console.log('Login successful, redirecting...')
          closeOTPGate()
          // Check user role and redirect appropriately
          if (userStore.isAdmin) {
            router.push('/admin')
          } else if (userStore.isWorkshop) {
            router.push('/workshop/jobs')
          } else {
            router.push('/customer/catalogue')
          }
        } else {
          console.log('Login failed:', result.error)
          // Handle specific error types
          const errorMessage = result.error.toLowerCase()
          
          // Clear previous errors
          emailError.value = ''
          passwordError.value = ''
          generalError.value = ''
          
          if (errorMessage.includes('invalid') || errorMessage.includes('credentials') || errorMessage.includes('invalid email/phone or password')) {
            passwordError.value = 'Invalid email/phone or password'
          } else if (errorMessage.includes('email') || errorMessage.includes('phone')) {
            emailError.value = result.error
          } else if (errorMessage.includes('login attempt limit')) {
            generalError.value = 'You have used all your allowed logins. Please contact support to restore access.'
          } else if (errorMessage.includes('deactivated') || errorMessage.includes('account has been deactivated')) {
            generalError.value = 'Account has been deactivated. Please contact support.'
          } else {
            // For any other errors, show in general error area
            generalError.value = result.error
          }
        }
      } catch (error) {
        console.error('Login error:', error)
        // Clear previous errors
        emailError.value = ''
        passwordError.value = ''
        generalError.value = ''
        
        // Show error in general area
        generalError.value = 'Login failed. Please try again.'
      } finally {
        loading.value = false
      }
    }

    const accessSecretProduct = async () => {
      if (!secretKeyInput.value.trim()) {
        secretKeyError.value = 'Secret key is required'
        return
      }

      loadingSecret.value = true
      secretKeyError.value = ''
      secretProduct.value = null
      
      try {
        console.log('Landing page: Attempting to access secret product with key:', secretKeyInput.value)
        
        // Get the product using the public API
        const { productsAPI } = await import('@/services/api')
        const response = await productsAPI.getProductBySecretKeyPublic(secretKeyInput.value)
        
        if (response.data.product) {
          console.log('Landing page: Product found:', response.data.product)
          secretProduct.value = response.data.product
          secretKeyInput.value = '' // Clear the input
        } else {
  
          secretKeyError.value = 'Invalid secret key'
        }
        
      } catch (error) {
        console.error('Landing page: Secret key validation error:', error)
        if (error.response?.status === 404) {
          secretKeyError.value = 'Invalid secret key'
        } else {
          secretKeyError.value = 'Failed to access secret product. Please try again.'
        }
      } finally {
        loadingSecret.value = false
      }
    }

    const testSecretKey = async () => {
      secretKeyInput.value = 'EXCLUSIVE-2024'
      await accessSecretProduct()
    }

    const clearSecretProduct = () => {
      secretProduct.value = null
      secretKeyError.value = ''
    }

    const addSecretProductToCart = async () => {
      if (!secretProduct.value) return
      
      addingToCart.value = true
      try {
        // Store the product info for after OTP validation
        sessionStorage.setItem('pendingCartProduct', JSON.stringify({
          productId: secretProduct.value.id,
          secretKey: secretProduct.value.secret_key,
          accessedViaSecret: true
        }))
        
        // Show OTP gate for authentication
        showOTPGate.value = true
        tab.value = 'token' // Changed to token tab
        
      } catch (error) {
        console.error('Error adding secret product to cart:', error)
      } finally {
        addingToCart.value = false
      }
    }

    // Image Viewer Methods
    const openImageModal = () => {
      if (productImages.value.length > 0) {
        currentImageIndex.value = 0
        showImageModal.value = true
      }
    }

    const closeImageModal = () => {
      showImageModal.value = false
      currentImageIndex.value = 0
    }

    const nextImage = () => {
      if (productImages.value.length > 1) {
        currentImageIndex.value = (currentImageIndex.value + 1) % productImages.value.length
      }
    }

    const previousImage = () => {
      if (productImages.value.length > 1) {
        currentImageIndex.value = currentImageIndex.value === 0 
          ? productImages.value.length - 1 
          : currentImageIndex.value - 1
      }
    }

    const setCurrentImage = (index) => {
      currentImageIndex.value = index
    }

    const handleImageError = (event) => {
      // Replace broken image with placeholder
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRkZGRkZGIi8+CjxwYXRoIGQ9Ik0xMDAgNTBDMTIzLjE5NiA1MCAxNDIgNjguODA0IDE0MiA5MkMxNDIgMTE1LjE5NiAxMjMuMTk2IDEzNCAxMDAgMTM0Qzc2LjgwNCAxMzQgNTggMTE1LjE5NiA1OCA5MkM1OCA2OC44MDQgNzYuODA0IDUwIDEwMCA1MFoiIGZpbGw9IiNGRkMxMDciLz4KPHBhdGggZD0iTTEwMCAxNTRDMTIzLjE5NiAxNTQgMTQyIDE3Mi44MDQgMTQyIDE5NkMxNDIgMjE5LjE5NiAxMjMuMTk2IDIzOCAxMDAgMjM4Qzc2LjgwNCAyMzggNTggMjE5LjE5NiA1OCAxOTZDNTggMTcyLjgwNCA3Ni44MDQgMTU0IDEwMCAxNTRaIiBmaWxsPSIjRkZDMTA3Ii8+Cjwvc3ZnPgo='
    }

    const getImageUrl = (imageName) => {
      // Return placeholder if no image name
      if (!imageName) {
        return 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgdmlld0JveD0iMCAwIDIwMCAyMDAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBmaWxsPSIjRkZGRkZGIi8+CjxwYXRoIGQ9Ik0xMDAgNTBDMTIzLjE5NiA1MCAxNDIgNjguODA0IDE0MiA5MkMxNDIgMTE1LjE5NiAxMjMuMTk2IDEzNCAxMDAgMTM0Qzc2LjgwNCAxMzQgNTggMTE1LjE5NiA1OCA5MkM1OCA2OC44MDQgNzYuODA0IDUwIDEwMCA1MFoiIGZpbGw9IiNGRkMxMDciLz4KPHBhdGggZD0iTTEwMCAxNTRDMTIzLjE5NiAxNTQgMTQyIDE3Mi44MDQgMTQyIDE5NkMxNDIgMjE5LjE5NiAxMjMuMTk2IDIzOCAxMDAgMjM4Qzc2LjgwNCAyMzggNTggMjE5LjE5NiA1OCAxOTZDNTggMTcyLjgwNCA3Ni44MDQgMTU0IDEwMCAxNTRaIiBmaWxsPSIjRkZDMTA3Ii8+Cjwvc3ZnPgo='
      }
      
      // If it's a full URL, return as is
      if (imageName.startsWith('http://') || imageName.startsWith('https://')) {
        return imageName
      }
      
      // Use the nginx proxy for uploads
      const baseUrl = import.meta.env.VITE_API_URL || ''
      const url = `${baseUrl}/uploads/${imageName}`
      return url
    }
    
    function goToInviteRegistration() {
      router.push('/invite-registration')
    }

    const tokenStep = ref(1)
    const inviteToken = ref('')
    const tokenLoading = ref(false)
    const tokenError = ref('')
    const inviteDetails = ref(null)
    const tokenForm = ref({ username: '', password: '', gst_number: '', contact_person: '', email: '', phone: '', address: '' })
    const showRegisterPassword = ref(false)
    const notification = useNotificationStore()

    // Explain a forced logout (session expired / signed in elsewhere) set by the API layer
    onMounted(() => {
      const notice = sessionStorage.getItem('authNotice')
      if (notice) {
        sessionStorage.removeItem('authNotice')
        notification.showWarning('Signed out', notice)
      }
    })
    const gstError = ref('')

    const validateGST = () => {
      if (!tokenForm.value.gst_number) {
        gstError.value = ''
        return
      }
      // GSTIN regex: 2 digits, 5 letters, 4 digits, 1 letter, 1 alphanumeric, 1 Z, 1 alphanumeric
      const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/i
      if (!gstRegex.test(tokenForm.value.gst_number)) {
        gstError.value = 'Please enter a valid GST number (e.g., 22AAAAA0000A1Z5)'
      } else {
        gstError.value = ''
      }
    }

    const getErrorMessage = (error) => {
      if (!error) return ''
      
      // Map backend error messages to user-friendly messages
      const errorMap = {
        'InvalidToken': 'The invite token is invalid or has expired. Please check your token and try again.',
        'TokenExpired': 'This invite token has expired. Please contact support for a new token.',
        'UserExists': 'An account with this email, phone, or username already exists. Please use different credentials.',
        'Invalid GST number format': 'Please enter a valid GST number in the format: 22AAAAA0000A1Z5',
        'Invalid email format': 'Please enter a valid email address.',
        'Password must be at least 6 characters': 'Password must be at least 6 characters long.',
        'Username is required': 'Please enter a username.',
        'Email is required': 'Please enter your email address.',
        'Phone is required': 'Please enter your phone number.'
      }
      
      // Check for specific error types
      for (const [key, message] of Object.entries(errorMap)) {
        if (error.includes(key) || error.toLowerCase().includes(key.toLowerCase())) {
          return message
        }
      }
      
      // Default error message
      return error || 'An error occurred. Please try again.'
    }

    const validateToken = async () => {
      tokenError.value = ''
      tokenLoading.value = true
      try {
        const res = await api.post('/auth/invite/validate', { token: inviteToken.value })
        inviteDetails.value = res.data.invite
        tokenStep.value = 2
        if (inviteDetails.value.email) tokenForm.value.email = inviteDetails.value.email
        if (inviteDetails.value.phone) tokenForm.value.phone = inviteDetails.value.phone
      } catch (e) {
        tokenError.value = e.response?.data?.message || 'Invalid or expired token.'
        notification.showError('Token Validation Failed', tokenError.value)
      } finally {
        tokenLoading.value = false
      }
    }
    const registerViaToken = async () => {
      tokenError.value = ''
      tokenLoading.value = true
      try {
        const payload = { ...tokenForm.value, token: inviteToken.value }
        await api.post('/auth/invite/register', payload)
        tokenStep.value = 3
        notification.showSuccess('Registration Successful', 'You can now log in with the password you set.')
      } catch (e) {
        tokenError.value = e.response?.data?.message || 'Registration failed.'
        notification.showError('Registration Failed', tokenError.value)
      } finally {
        tokenLoading.value = false
      }
    }
    
    return {
      showOTPGate,
      tab,
      activeSection,
      email,
      password,
      showLoginPassword,
      emailError,
      passwordError,
      generalError,
      loginWithPassword,
      closeOTPGate,
      continueToLogin,
      switchTab,
      secretKeyInput,
      secretKeyError,
      loadingSecret,
      accessSecretProduct,
      secretProduct,
      addingToCart,
      testSecretKey,
      clearSecretProduct,
      addSecretProductToCart,
      showImageModal,
      currentImageIndex,
      productImages,
      currentImage,
      openImageModal,
      closeImageModal,
      nextImage,
      previousImage,
      setCurrentImage,
      getImageUrl,
      handleImageError,
      validateIdentifierInput,
      validatePhoneInput,
      goToInviteRegistration,
      tokenStep,
      inviteToken,
      tokenLoading,
      tokenError,
      inviteDetails,
      tokenForm,
      showRegisterPassword,
      validateToken,
      registerViaToken,
      loading,
      gstError,
      validateGST,
      getErrorMessage
    }
  }
}
</script> 

<style scoped>
/* Luxury Animations */
@keyframes shimmer {
  0% { background-position: -200px 0; }
  100% { background-position: calc(200px + 100%) 0; }
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
}

@keyframes sparkle {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 0.8; transform: scale(1.1); }
}

/* Luxury Button Effects */
.group:hover .shadow-3xl {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

/* Floating Elements Animation */
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.delay-1000 {
  animation-delay: 1s;
}

.delay-2000 {
  animation-delay: 2s;
}

/* Luxury Gradient Text */
.font-luxury {
  font-family: 'Playfair Display', serif;
}

.font-elegant {
  font-family: 'Cormorant Garamond', serif;
}

.font-modern {
  font-family: 'Inter', system-ui, sans-serif;
}

/* Enhanced Focus States */
.focus\:ring-amber-500:focus {
  --tw-ring-color: rgb(245 158 11);
}

.focus\:border-amber-500:focus {
  border-color: rgb(245 158 11);
}

/* Luxury Modal Backdrop */
.backdrop-blur-sm {
  backdrop-filter: blur(4px);
}

/* Enhanced Shadows */
.shadow-2xl {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.shadow-3xl {
  box-shadow: 0 35px 60px -12px rgba(0, 0, 0, 0.35);
}

/* Luxury Transitions */
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
}

/* Jewelry Pattern Background */
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}

/* Luxury Button Hover Effects */
.group:hover .transform {
  transform: scale(1.05);
}

/* Enhanced Typography */
.font-light {
  font-weight: 300;
}

/* Luxury Color Palette */
.from-amber-50 {
  --tw-gradient-from: #fffbeb;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgba(255, 251, 235, 0));
}

.via-yellow-50 {
  --tw-gradient-stops: var(--tw-gradient-from), #fefce8, var(--tw-gradient-to, rgba(254, 252, 232, 0));
}

.to-orange-50 {
  --tw-gradient-to: #fff7ed;
}

/* Luxury Border Effects */
.border-amber-200\/20 {
  border-color: rgba(253, 230, 138, 0.2);
}

/* Enhanced Spacing */
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 1.5rem;
}

/* Luxury Input Styling */
input:focus {
  outline: none;
  border-color: rgb(245 158 11);
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);
}

/* Luxury Button Styling */
button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Spinner Animation */
.spinner {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

@keyframes fade-in {
  from { opacity: 0; transform: translateY(40px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fade-in {
  animation: fade-in 1.2s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Modern Toggle Switch Animations */
@keyframes slide-in {
  from { 
    opacity: 0; 
    transform: translateX(-20px) scale(0.95); 
  }
  to { 
    opacity: 1; 
    transform: translateX(0) scale(1); 
  }
}

@keyframes slide-out {
  from { 
    opacity: 1; 
    transform: translateX(0) scale(1); 
  }
  to { 
    opacity: 0; 
    transform: translateX(20px) scale(0.95); 
  }
}

@keyframes bounce-in {
  0% { 
    opacity: 0; 
    transform: scale(0.3) translateY(-20px); 
  }
  50% { 
    opacity: 0.8; 
    transform: scale(1.05) translateY(-5px); 
  }
  100% { 
    opacity: 1; 
    transform: scale(1) translateY(0); 
  }
}

@keyframes pulse-glow {
  0%, 100% { 
    box-shadow: 0 0 0 0 rgba(251, 146, 60, 0.4); 
  }
  50% { 
    box-shadow: 0 0 0 8px rgba(251, 146, 60, 0.1); 
  }
}

/* Enhanced Toggle Switch Styling */
.toggle-slider {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform, width, left;
}

.toggle-button {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  will-change: transform, color, font-weight;
}

.toggle-button:hover {
  transform: translateY(-1px);
}

.toggle-button:active {
  transform: translateY(0) scale(0.98);
}

/* Content Transition Enhancements */
.content-enter-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.content-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Icon Animation */
.icon-scale {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.icon-scale:hover {
  transform: scale(1.1) rotate(5deg);
}

/* Glow Effect for Active State */
.glow-effect {
  position: relative;
}

.glow-effect::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(45deg, #f97316, #dc2626, #f97316);
  border-radius: inherit;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: -1;
}

.glow-effect.active::before {
  opacity: 0.3;
  animation: pulse-glow 2s infinite;
}
</style> 